import React, { useRef, useEffect } from "react"
import SEO from "../components/seo"
//Context
import {
  useGlobalStateContext,
  useGlobalDispatchContext,
} from "./../context/globalContext"
import { HomeProvider } from "./../context/homeContext"
//Components
import Presentation from "./../components/home/presentation"
import Slogan from "./../components/home/slogan"
import Contact from "./../components/home/contact"
import Biography from "../components/home/biography"
import WallToWorks from "../components/wallToWorks"
import WallToAbout from "../components/wallToAbout"
//Transition
import { homeEnter } from "./../components/transition/homePageTransition"
//Styled Components
import { HomeContainer, HomeWrapper } from "./../styles/homeStyles"
//Data
import { homeDescription } from "./../data/data-seo"
import { homeText } from "./../data/data-text"

const IndexPage = () => {
  //Contexts
  const { cursorStyles, globalLanguage } = useGlobalStateContext()
  const globalDispatch = useGlobalDispatchContext()
  //Texts
  const { slogan, biography, locate } = homeText[`${globalLanguage}`]

  //Refs
  const homeContainer = useRef(null)
  const requestRef = useRef(null)
  const dataScroll = useRef({
    ease: 0.095,
    actual: 0,
    previous: 0,
    rounded: 0,
  })
  //Functions
  const onCursor = (entry = "hover") => {
    const style = cursorStyles[`${entry}`].style
    globalDispatch({ type: "CURSOR_TYPE", payload: style })
  }

  const smoothScrolling = () => {
    dataScroll.current.actual = window.scrollY
    dataScroll.current.previous +=
      (dataScroll.current.actual - dataScroll.current.previous) *
      dataScroll.current.ease
    dataScroll.current.rounded =
      Math.round(dataScroll.current.previous * 100) / 100

    if (homeContainer.current) {
      homeContainer.current.style.transform = `translate3d(0, -${dataScroll.current.rounded}px, 0)` // skewY(${skew}deg)`
      requestRef.current = requestAnimationFrame(smoothScrolling)
    }
  }

  const setBodyHeight = () => {
    const page = document.body
    page.style.height = `${
      homeContainer.current.getBoundingClientRect().height
    }px`
  }

  const onResize = _ => {
    setBodyHeight()
  }

  //Effects Hooks
  useEffect(() => {
    homeEnter(homeContainer.current)
    setBodyHeight()
    requestRef.current = requestAnimationFrame(smoothScrolling)
    window.addEventListener("resize", onResize)

    return () => {
      cancelAnimationFrame(requestRef.current)
      window.removeEventListener("resize", onResize)
      document.body.style.height = 0
    }
    //eslint-disable-next-line
  }, [])

  return (
    <>
      <SEO title="Home" description={homeDescription} pic={0} />
      <WallToWorks />
      <WallToAbout />
      <HomeProvider>
        <HomeWrapper className="globalContainer">
          <HomeContainer className="home-container" ref={homeContainer}>
            <Presentation onCursor={onCursor} />
            <Slogan sloganText={slogan} />
            <Biography onCursor={onCursor} biographyText={biography} />
            <Contact locateText={locate} />
          </HomeContainer>
        </HomeWrapper>
      </HomeProvider>
    </>
  )
}

export default IndexPage
